import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { type IAlertLinkAction, type IAlertNavLinkAction } from 'shared/ui/Alert/types'
import { LINK_COMPLIANCE_LEARN_MORE_LINK } from 'shared/constants/links'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const AlertMaxSegments = observer(() => {
  const { conversationStore, usersStore, tenDlcLimitsStore } = useEntitiesContext()
  const user = usersStore.user

  const isAircall = !!conversationStore?.conversationInboxNumber?.is_aircall
  const isTollFree = conversationStore?.conversationInboxNumber?.isTollFree

  if (isTollFree || !tenDlcLimitsStore.isOutOfSegments) return null

  const isRoleMember = !!user?.isMemberRole
  const isRoleAdmin = !!(user?.isOwnerRole ?? user?.isAdminRole ?? user?.isManagerRole)

  const isActionHelp = isRoleMember && !isTollFree
  const isActionSettings = isRoleAdmin && !isAircall

  const title = isRoleAdmin
    ? tenDlcLimitsStore.isPlanStarter
      ? 'You’re required to register for 10DLC compliance.'
      : 'You have exceeded the limits of your current 10DLC package.'
    : tenDlcLimitsStore.isPlanStarter
    ? 'Your company is required to register for 10DLC compliance.'
    : 'You have exceeded the limits of your current 10DLC package.'

  const description = isRoleAdmin
    ? tenDlcLimitsStore.isPlanStarter
      ? 'To avoid being blocked and paying carrier penalty fees, and message filtering'
      : 'Upgrade to avoid non-compliance fees and message filtering'
    : tenDlcLimitsStore.isPlanStarter
    ? 'To avoid being blocked and paying carrier penalty fees, alert your admin'
    : 'To avoid being blocked and paying carrier penalty fees, alert your admin'

  const action: IAlertLinkAction | IAlertNavLinkAction | null = isActionHelp
    ? {
        variant: 'link',
        type: 'primary',
        text: 'Learn more',
        link: LINK_COMPLIANCE_LEARN_MORE_LINK,
      }
    : isActionSettings
    ? {
        variant: 'navLink',
        type: 'primary',
        text: 'Register here',
        link: '/settings/organization/compliance',
        appType: 'vue',
      }
    : null

  return (
    <Alert
      item={{ title, desc: description, type: 'error' }}
      actions={action ? [action] : undefined}
    />
  )
})
